// Coming from Survey or IF
const OPENERS_NOT_ALLOWED_TO_SEE_PLAYLIST = [
  'survey-response',
  'incoming-feedback-response',
  'highlight',
];

export const getPlaylistVisibility = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  const isScreenshotMode = searchParams.get('forScreenshot');
  const isHighlightMode = searchParams.get('forHighlight');
  const isRetakerMode = searchParams.get('forRetaker');
  const isPublicRecording = searchParams.get('token');
  const isNotAllowedToSeePlaylist = OPENERS_NOT_ALLOWED_TO_SEE_PLAYLIST.includes(
    searchParams.get('opener') || '',
  );

  const isPlaylistVisible = !(
    isScreenshotMode ||
    isHighlightMode ||
    isRetakerMode ||
    isPublicRecording ||
    isNotAllowedToSeePlaylist
  );

  return isPlaylistVisible;
};
